// extracted by mini-css-extract-plugin
export default {"singleSelect":"single-select_singleSelect__9s4E6","selectText":"single-select_selectText__Og9UD"};